import { ArrowLeftIcon } from '@components/Icons/ArrowLeftIcon';
import { Box } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import css from './BackToPage.module.scss';

export const BackTo = ({
  href,
  useBrowserHistory,
  children,
  ...props
}: {
  href?: string;
  useBrowserHistory?: boolean;
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    if (useBrowserHistory) {
      e.preventDefault();
      // Only use navigate(-1) if the previous page was from the same app
      const referrer = document.referrer;
      const isSameDomain = referrer && new URL(referrer).origin === window.location.origin;

      if (isSameDomain) {
        // Safe to go back - user came from within the app
        navigate(-1 as any, { replace: false });
      } else {
        // Previous page was external - use explicit navigation
        navigate('/', { replace: false });
      }
    }
  };

  return (
    <Box className={css.container} draggable={false} {...props}>
      {useBrowserHistory ? (
        <Link to="#" onClick={handleClick} className={css.backToPageLink} draggable={false}>
          <ArrowLeftIcon /> {children}
        </Link>
      ) : (
        <Link to={href || '/'} className={css.backToPageLink} draggable={false}>
          <ArrowLeftIcon /> {children}
        </Link>
      )}
    </Box>
  );
};
